<template>
  <standardTable :standard="$store.getters.standard" :standardTitle="$store.getters.standardTitle"/>
</template>

<script>
import standardTable from '../components/standardTable'

export default {
  name: 'List',
  components: {
    standardTable
  },
  filters: {},
  mixins: {},
  props: {},
  data: function () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  methods: {}
}
</script>
